<template>
  <v-container fluid fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              insert_chart
            </v-icon>
            <span class="title">Dashboard</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-row>
                  <v-col cols="12" md="12" class="pt-0">
                    <v-card
                      :color="maincolor"
                      dark
                      outlined>
                      <v-card-title class="title py-3">Berdasar Negara</v-card-title>
                      <v-card-text class="white text--primary py-3">
                        <v-data-table
                          class="table-nowrap"
                          light
                          :headers="summary.negara.headers"
                          :items="summary.negara.data"
                          hide-default-footer>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-card
                      :color="maincolor"
                      dark
                      outlined>
                      <v-card-title class="title py-3">Berdasar Categori Usia</v-card-title>
                      <v-card-text class="white text--primary py-3">
                        <v-data-table
                          class="table-nowrap"
                          light
                          :headers="summary.usia.headers"
                          :items="summary.usia.data"
                          hide-default-footer>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-card
                      :color="maincolor"
                      dark
                      outlined>
                      <v-card-title class="title py-3">Berdasar Kelamin</v-card-title>
                      <v-card-text class="white text--primary py-3">
                        <v-data-table
                          class="table-nowrap"
                          light
                          :headers="summary.kelamin.headers"
                          :items="summary.kelamin.data"
                          hide-default-footer>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-card outlined>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-btn
                          large
                          block
                          color="success"
                          class="mt-1"
                          dark
                          @click="updateDashboard">
                          Download
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="12" class="text-right py-0">
                        <span class="caption">
                          Tekan tombol <span class="red--text font-weight-bold">DOWNLOAD</span> untuk mengunduh Report.
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="8">
                <div class="text-center" v-if="loading.dashboard">
                  <v-progress-circular
                    :width="3"
                    color="red"
                    indeterminate>
                  </v-progress-circular>
                </div>
                <v-card
                  v-if="!loading.dashboard"
                  outlined
                  class="mx-auto"
                  light>
                  <v-card-text>
                    <v-row v-show="stockOptionsAll.series.length">
                      <v-col cols="12" md="12" class="py-0">
                        <span class="title black--text">Profile Pelanggan</span>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card
                          class="mx-auto text-center"
                          color="red"
                          dark>
                          <v-card-text>
                            <v-icon size="40" dark>mdi-vote</v-icon>
                            Jumlah pelanggan
                          </v-card-text>
                          <v-card-text>
                            <div class="display-1">
                              {{ datasummary.tpelanggan }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card
                          class="mx-auto text-center"
                          color="orange"
                          dark>
                          <v-card-text>
                            <v-icon size="40" dark>mdi-star-box-multiple</v-icon>
                            Mancanegara
                          </v-card-text>
                          <v-card-text>
                            <div class="display-1">
                              {{ datasummary.twisman }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card
                          class="mx-auto text-center"
                          color="primary"
                          dark>
                          <v-card-text>
                            <v-icon size="40">mdi-star-box</v-icon>
                            Nusantara
                          </v-card-text>
                          <v-card-text>
                            <div class="display-1">
                              {{ datasummary.twislok }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="12" class="px-0">
                        <div
                          class="display-1">
                          <highcharts
                            class="stock"
                            :options="stockOptionsAll"
                            ref="highchartstockall">
                          </highcharts>
                        </div>
                      </v-col>
                      <v-col cols="12" md="12" class="pb-0" v-if="false">
                        <span class="title black--text">Profile masing-masing unit</span>
                      </v-col>
                      <v-col cols="12" md="12" class="pt-0" v-if="false">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">
                                  Name
                                </th>
                                <th class="text-left">
                                  Rating
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in tblsummary"
                                :key="item.name">
                                <td>{{ item.name }}</td>
                                <td>{{ item.avgdata }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <h3 v-show="!stockOptionsAll.series.length">
                      Ubah parameter untuk menemukan data yang lain!
                    </h3>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DashboardAdmin',
  data: () => ({
    loading: {
      dashboard: false,
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    filter: {
      unit: null,
      rangedate: [],
    },
    varsemua: 'Semua',
    listunit: [],
    datasummary: {
      tpelanggan: 0,
      twisman: 0,
      twislok: 0,
    },
    tblsummary: [],
    rules: {
      required: (value) => !!value || 'Required.',
    },
    stockOptionsAll: {
      chart: {
        type: 'line',
      },
      title: {
        text: 'Grafik laju rating',
        align: 'left',
      },
      xAxis: {
        type: 'category',
        categories: [],
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Rating',
        },
      },
      tooltip: {
        headerFormat: 'Tanggal: {point.x}<br>',
        pointFormat: 'Rating: {point.y:.1f}<br>',
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      series: [],
    },
    summary: {
      usia: {
        headers: [
          { text: 'Usia', value: 'range_umur' },
          { text: 'Jumlah', value: 'jum' },
        ],
        data: [],
      },
      kelamin: {
        headers: [
          { text: 'Kelamin', value: 'pel_kelamin' },
          { text: 'Jumlah', value: 'jum' },
        ],
        data: [],
      },
      negara: {
        headers: [
          { text: 'Negara', value: 'pel_negara' },
          { text: 'Jumlah', value: 'jum' },
        ],
        data: [],
      },
    },
  }),
  created: () => ({
  }),
  mounted() {
    this.updateDashboard();
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'useremail',
    ]),
    dateRangeText() {
      return this.filter.rangedate.join(' ~ ');
    },
  },
  methods: {
    getUnit() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/unit/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listunit = resdata.data;
                // if (this.listunit.length > 0) {
                //   this.filter.unit = this.listunit[0];
                // }
                const allfilter = {
                  nama_unit: 'Semua',
                  id_unit: 'all',
                };
                this.listunit.push(allfilter);
                this.filter.unit = allfilter;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    updateDashboard() {
      if (this.tokenscr) {
        // console.log(this.filter);
        this.summary.usia.data = [];
        this.summary.kelamin.data = [];
        this.summary.negara.data = [];
        this.loading.dashboard = true;
        this.stockOptionsAll.xAxis.categories = [];
        this.stockOptionsAll.series = [];
        this.datasummary = {
          tpelanggan: 0,
          twisman: 0,
          twislok: 0,
        };
        // console.log(datasend);
        this.axios
          .get(
            this.api + '/api/pelanggan/dashboard',
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // console.log(resdata);
                // statistik
                this.summary.negara.data = resdata.sumnegara;
                this.summary.kelamin.data = resdata.sumkelamin;
                this.summary.usia.data = resdata.sumusia;
                // grafik
                if (resdata.data.length > 0) {
                  const category = [];
                  const series = [];
                  const dgroup = [];
                  let tpelanggan = 0;
                  let twisman = 0;
                  let listgroup = {};
                  for (const row of resdata.data) {
                    tpelanggan += parseInt(row.jum, 10);
                    if (row.tipe === 'Wisman') {
                      twisman += parseInt(row.jum, 10);
                    }
                    category.push(row.tahun);
                    series.push(parseFloat(row.jum));
                    listgroup = {
                      year: row.tahun,
                      jum: parseFloat(row.jum),
                    };
                    (dgroup[row.tipe] = dgroup[row.tipe] || []).push(listgroup);
                  }
                  // generate date
                  let listyear = [];
                  listyear = category.filter((item, pos) => {
                    return category.indexOf(item) === pos;
                  });
                  // generate data
                  let datachart = null;
                  const listdata = [];
                  Object.keys(dgroup).forEach((key) => {
                    // put each date
                    const eachdate = [];
                    let toteach = 0;
                    for (const year of listyear) {
                      let isadd = false;
                      for (const dg of dgroup[key]) {
                        if (dg.year === year) {
                          toteach += parseFloat(dg.jum);
                          eachdate.push(dg.jum);
                          isadd = true;
                        }
                      }
                      if (!isadd) {
                        eachdate.push(0);
                      }
                    }
                    // generate series
                    datachart = {
                      name: key,
                      data: eachdate,
                    };
                    listdata.push(datachart);
                  });
                  // generate grafik
                  this.stockOptionsAll.xAxis.categories = listyear;
                  this.stockOptionsAll.series = listdata;
                  // table summary
                  this.tblsummary = listdata;
                  // data summary
                  this.datasummary.tpelanggan = tpelanggan;
                  this.datasummary.twisman = twisman;
                  this.datasummary.twislok = tpelanggan - twisman;
                }
              }
            }
            this.loading.dashboard = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.dashboard = false;
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
